import { useState, useEffect } from 'react';

export function useStrapi(fetchFn, deps = []) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        setLoading(true);
        const result = await fetchFn();
        if (!cancelled) {
          setData(result.data || result);
          setError(null);
        }
      } catch (err) {
        if (!cancelled) {
          setError(err.message || 'Der opstod en fejl');
          // Use fallback data
          setData(null);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();
    return () => { cancelled = true; };
  // eslint-disable-next-line
  }, deps);

  return { data, loading, error };
}
